// ==========================================
// ApiEndpointConstants.js - API 接口常量配置
// ==========================================

export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://ack.quanqiupay.com";

export default {
  // 认证相关
  GETCODE: "/api/send_login_code.php", // 生成验证码
  MANAGERLOGIN: "/api/verify_admin_code.php", // 管理员登录
  REGISTER: "/api/register.php", // 用户注册
  LOGIN: "/api/login.php", // 用户登录
  GET_USER: "/api/user.php", // 获取当前用户信息

  // 用户管理（管理员专用）
  GETUSERLIST: "/api/admin_users_list.php", // 获取用户列表
  ADD_USER: "/api/admin_users.php", // 添加修改用户信息
  UPDATE_USER_PASSWORD: "/api/admin_update_user_password.php", // 修改用户密码
  DELETE_USER: "/api/admin_delete_user.php", // 删除用户
  STATISTIC: "/api/statistics.php", //统计数据

  //账户管理
  ACCOUNTMANAGE: "/api/merchant_accounts.php", //账户管理
  GETACCOUNTDETAILS: "/api/merchant_account_detail.php", // 获取账户详情
  ADD_MERCHANT_ACCOUNT: "/api/add_merchant_account.php", // 添加/更新收款账户
  DELETE_MERCHANT_ACCOUNT: "/api/delete_merchant_account.php", // 删除收款账户
  DELETE_TRANSACTION: "/api/delete_transaction.php", // 删除交易记录

  //交易
  GETTRANSACTIONSLIST: "/api/transactions_list.php", // 获取交易列表
  GETTRANSACTIONDETAIL: "/api/transaction_detail.php", // 获取交易详情
  ADD_TRANSACTION: "/api/add_transaction.php", // 新增修改交易记录（尝试使用admin_前缀）
  CONFIRMTRANSACTION: "/api/confirm_transaction.php", //管理员确认交易到账
  UPDATE_TRANSACTION_STATUS: "/api/update_transaction_status.php", // 更新交易状态（审核、到账、退款等）
  DELETETRANSACTION: "/api/delete_transaction.php", //管理员删除订单

  // 消息中心
  MESSAGES_LIST: "/api/messages_list.php", // 获取消息列表
  MESSAGE_DETAIL: "/api/message_detail.php", // 获取消息详情（自动标记已读）
  MARK_MESSAGE_READ: "/api/mark_message_read.php", // 标记消息为已读
  MARK_ALL_READ: "/api/mark_all_read.php", // 标记所有消息为已读
  GET_UNREAD_COUNT: "/api/get_unread_count.php", // 获取未读消息数量
  SEND_MESSAGE: "/api/send_message.php", // 发送消息
  DELETE_MESSAGE: "/api/delete_message.php", // 删除消息
  ADD_OR_UPDATE_MESSAGE: "/api/add_or_update_message.php", // 新增/编辑消息（管理员）

  //统计
  GET_CURRENCY_STATS: "/api/get_credited_amount_stats.php", // 获取按币种分组的金额统计
  GET_DAILY_CREDITED_AMOUNT: "/api/get_daily_credited_amount.php", // 获取按日期统计的入账金额
};
